export const ComponentBiomatchOrientations = {
	'Self Enrollment Process': 'New user registration',
	'Facial recognition allows us to validate and guarantee the transparency and quality of the courses we offer you. Next we will request photographs of your identity card and your face. To start the process, click the button below.':
		'Facial recognition lets us validate and guarantee the transparency and quality of the courses we offer you. To begin, have your ID card handy and find a place with good lighting.',
	Start: 'Next',
	Back: 'Previous',
	Take: 'Take',
	Rotate: 'Rotate',
	'Try again': 'Try again',
	Repeat: 'Repeat',
	'Final Validation': 'Final validation',
	'Uploading info...': 'Uploading data...',
	// Biomatch data labels
	'Foto de Sefie': 'Face photo',
	'Gire su rostro hacia Arriba': 'Photo looking up',
	'Gire su rostro a su Derecha': 'Photo looking to the right',
	'CI frontal': 'ID front photo',
	'CI back': 'ID back photo',
	// Errors
	'There was an error in the validation':
		'There was an error in the validation',
	'Please consider the following and repeat the front photo, back photo and face photo:':
		'Please consider the following and repeat the front photo, back photo and face photo:',
	'Take care of excess or lack of light':
		'Watch for too much or too little light',
	'Avoid blurry photos': 'Avoid blurry photos',
	Retry: 'Retry',
	'Show tutorial': 'Show tutorial',
	'Taking photo': 'Take photo',
	Next: 'Next',
	Validate: 'Validate',
	Accept: 'Accept',
	'Subiendo y validando fotos': 'Uploading and validating photos',
};
